import { createSlice } from "@reduxjs/toolkit";
import { v4 as uuid } from "uuid";
import { toastSuccess, toastError, toastInfo, toastWarn } from "../components/ui/System/MobligoToast";
import { translate } from "../utils/language";

const systemSlice = createSlice({
    name: "preloader",
    initialState: {
        isLottiePreloader: null,
        isShowPreloaderCount: 0,
        toastSettings: {},
        imageCropperSettings: {},
        croppedImages: {},
        activeSubTabs: [],
        language: "tr",
        screenShotMode: false,
        OTPProps: {},
        iframeProps: {}
    }
    ,
    reducers: {
        setIsShow: (state, action) => {
            const payload = action?.payload
            if (payload) state.isShowPreloaderCount++
            else state.isShowPreloaderCount--
        },
        isLottiePreloader: (state, action) => {
            state.isLottiePreloader = action.payload;
        },
        setToastSettings: (state, action) => {
            const payload = action?.payload
            state.toastSettings = { ...payload, id: uuid() }
        },
        setToastError: (state, action) => {
            const payload = action?.payload
            const newToastError = { ...toastError, id: uuid(), summary: translate(payload?.summary || "error"), detail: translate(payload?.detail) }
            state.toastSettings = newToastError
        },
        setToastSuccess: (state, action) => {
            const payload = action?.payload
            const newToastSuccess = { ...toastSuccess, id: uuid(), summary: translate(payload?.summary || "success"), detail: translate(payload?.detail) }
            state.toastSettings = newToastSuccess
        },
        setToastInfo: (state, action) => {
            const payload = action?.payload
            const newToastInfo = { ...toastInfo, id: uuid(), summary: translate(payload?.summary || "info"), detail: translate(payload?.detail) }
            state.toastSettings = newToastInfo
        },
        setToastWarn: (state, action) => {
            const payload = action?.payload
            const newToastWarn = { ...toastWarn, id: uuid(), summary: translate(payload?.summary || "warn"), detail: translate(payload?.detail) }
            state.toastSettings = newToastWarn
        },
        setImageCropperSettings: (state, action) => {
            const payload = action?.payload
            state.imageCropperSettings = payload
        },
        setCroppedImages: (state, action) => {
            const payload = action?.payload
            state.croppedImages = { ...state.croppedImages, ...payload }
        },
        clearCroppedImages: (state, action) => {
            state.croppedImages = {}
        },
        setActiveSubTabs: (state, action) => {
            const payload = action?.payload
            state.activeSubTabs = payload
        },
        handleActiveSubTabs: (state, action) => {
            const payload = action?.payload
            const isClose = payload.isClose
            const tabId = payload.tabId
            if (isClose) {
                //@ts-ignore
                state.activeSubTabs = state.activeSubTabs.filter(stateTabId => !(stateTabId?.startsWith(tabId) && stateTabId !== tabId))
                return
            }
            //@ts-ignore

            if (state.activeSubTabs.includes(tabId)) return
            //@ts-ignore

            state.activeSubTabs = [...state.activeSubTabs, tabId]
        },
        setScreenShotMode: (state, action) => {
            state.screenShotMode = action.payload
        },
        setOTPProps: (state, action) => {
            state.OTPProps = action.payload
        },
        setIframeProps: (state, action) => {
            state.iframeProps = action.payload
        },
    },
});

export default systemSlice;
